import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import CircularProgress from "@mui/material/CircularProgress";
import formatPartCode from "helper/formatPartCode";

import partCodesService from "services/part-code-service";
import { useEffect, useState } from "react";

import ImageModal from "e4acomponents/ImageModal";

export default function ProductModelCard({ id }) {

    const [partCode, setPartCode] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [openImageModal, setOpenImageModal] = useState(false);

    // Fetches the partcode and it's image
    useEffect(() => {
        (async () => {
            if (!id) return;
            setIsLoading(true);
            const response = await partCodesService.getPartById(id);
            if (response.data.attributes.has_image) {
                const image = await partCodesService.getImage(response.data.attributes.imagePath);
                setImageUrl(image);
            } else {
                setImageUrl("https://ami-spotlight.footbridge.tilkal.com/resources/images/image.jpg");
            }
            if (partCode) {
                setTimeout(() => setPartCode(response.data.attributes), 500);
            } else {
                setPartCode(response.data.attributes);
            }
        })();
    }, [id]);

    useEffect(() => {
        if (partCode) {
            setIsLoading(false);
        }
    }, [partCode]);

    return (

        <Card>
            {isLoading ?
                (
                    <MDBox p={3} display="flex" justifyContent="center" alignItems="center" height="200px">
                        <CircularProgress />
                    </MDBox>
                ) : (
                    <MDBox p={3}>
                        <ImageModal
                            open={openImageModal}
                            onClose={() => setOpenImageModal(false)}
                            mediaURL={imageUrl}
                        />
                        <MDTypography variant="h4" fontWeight="bold">
                            Model's Details:
                        </MDTypography>

                        <Grid container spacing={2}>

                            <Grid item xs={12} lg={4}>
                                <MDBox
                                    onClick={() => setOpenImageModal(true)}
                                    sx={{ cursor: 'pointer' }}
                                >
                                    <img src={imageUrl} width="100%" />
                                </MDBox>
                            </Grid>

                            <Grid item xs={12} lg={8} p={2}>

                                <MDBox textAlign="center" mb={1}>
                                    <MDTypography variant="h5" fontWeight="medium">
                                        {partCode && (formatPartCode(partCode))}
                                    </MDTypography>
                                </MDBox>

                                {/* Description */}
                                <Grid container spacing={{ xs: 0, md: 4 }}>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="medium" textAlign={{ xs: "left", md: "right" }}>
                                            Description
                                        </MDTypography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="regular">
                                            {partCode && (partCode.description)}
                                        </MDTypography>
                                    </Grid>
                                </Grid>
                                {/* Manufacturer */}
                                <Grid container spacing={{ xs: 0, md: 4 }}>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="medium" textAlign={{ xs: "left", md: "right" }} mt={2}>
                                            Manufacturer
                                        </MDTypography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="regular" mt={{ xs: 0, md: 2 }}>

                                            {partCode && (partCode.manufacturer ? (partCode.manufacturer) : "N/A")}
                                        </MDTypography>
                                    </Grid>
                                </Grid>

                                {/* Manufacturer Part Number */}
                                <Grid container spacing={{ xs: 0, md: 4 }}>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="medium" textAlign={{ xs: "left", md: "right" }} mt={2}>
                                            Manufacturer Part Number
                                        </MDTypography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="regular" mt={{ xs: 0, md: 2 }}>
                                            {partCode && (partCode.manufacturer_part_number ? (partCode.manufacturer_part_number) : "N/A")}
                                        </MDTypography>
                                    </Grid>
                                </Grid>

                                {/* Vendor */}
                                <Grid container spacing={{ xs: 0, md: 4 }}>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="medium" textAlign={{ xs: "left", md: "right" }} mt={2}>
                                            Vendor
                                        </MDTypography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="regular" mt={{ xs: 0, md: 2 }}>
                                            {partCode && (partCode.vendors ? (partCode.vendors[`vendor-1`]) : "N/A")}
                                        </MDTypography>
                                    </Grid>
                                </Grid>

                                {/* Vendor Part Number */}
                                <Grid container spacing={{ xs: 0, md: 4 }}>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="medium" textAlign={{ xs: "left", md: "right" }} mt={2}>
                                            Vendor Part Number
                                        </MDTypography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="regular" mt={{ xs: 0, md: 2 }}>
                                            {partCode && (partCode.vendor_part_number ? (partCode.vendor_part_number) : "N/A")}
                                        </MDTypography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </MDBox>
                )}
        </Card>

    )
}